/**
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Import portions of React that are needed.
import React from 'react'; // Other standard imports.

import { string } from 'prop-types';
export var HTTPErrorSvg404 = function HTTPErrorSvg404(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1584 916",
    className: className,
    preserveAspectRatio: "xMinYMax meet"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M412 617.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M416 624.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M398.19 625.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M402.19 632.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M384.33 633.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M388.33 640.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M370.48 641.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M374.48 648.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M356.62 649.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M360.62 656.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M342.76 657.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M346.76 664.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M328.91 665.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M332.91 672.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M315.05 673.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M319.05 680.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M301.19 681.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M305.19 688.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M287.34 689.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M291.34 696.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M273.48 697.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M277.48 704.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M259.62 705.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M263.62 712.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M245.77 713.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M249.77 720.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M231.91 721.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M235.91 728.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M218.05 729.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M222.05 736.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M204.2 737.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M208.2 744.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M190.34 745.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M194.34 752.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M176.49 753.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M180.49 760.38a4 4 0 11-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M162.63 761.45a4 4 0 014 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M166.63 768.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M148.77 769.45a4 4 0 114 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M152.77 776.38a4 4 0 01-4-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M138.92 768.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M134.92 775.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M125.06 760.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M121.06 767.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M111.2 752.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M107.2 759.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M97.35 744.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M93.35 751.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M83.49 736.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M79.49 743.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M69.63 728.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M65.63 735.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M55.78 720.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M51.78 727.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M41.92 712.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M37.92 719.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M28.06 704.48a4 4 0 11-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M24.06 711.41a4 4 0 114-6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M14.21 696.48a4 4 0 01-4 6.93z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M10.21 703.41a4 4 0 014-6.93z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient",
    x1: 285.88,
    y1: 580.96,
    x2: 237.44,
    y2: 552.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#bebebe",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-2",
    x1: 313.9,
    y1: 557.49,
    x2: 265.87,
    y2: 529.75,
    xlinkHref: "#prefix__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-3",
    x1: 410.05,
    y1: 763.45,
    x2: 1315.84,
    y2: 763.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, '.prefix__cls-1{fill:none}.prefix__cls-67{fill:#697077}.prefix__cls-68{fill:#282828}.prefix__cls-69{fill:#51565c}.prefix__cls-70{fill:#002b50}.prefix__cls-71{fill:#413d3d}.prefix__cls-72{fill:#908b8b}.prefix__cls-75{fill:#a4a4a5}.prefix__cls-76{opacity:.15}')), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: 'isolate'
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient)",
    d: "M280.21 590.78l-42.54-33.75 5.44-13.87 43.45 25.09-6.35 22.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__linear-gradient-2)",
    d: "M273.15 530.82l43.45 22-9.98 6.69-43.45-25.08 9.98-3.61z"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    strokeDasharray: "0 16",
    stroke: "url(#prefix__linear-gradient-3)",
    fill: "none",
    d: "M414.05 620.91l336.71 194.4 202.03-116.64L1311.84 906"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(412 609)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSSw7AIAhEh6Ynbc/lWemmYwz+hvatTMQXYDR3Rwa7UR94gfF8jMvHtJLuTuloJWBX56wAWAsi09FUCeu60VRBpI72VUAMl7BtgVT8M7zAfouk+Fe0vxp4U8ssOgpIjX8nmwmItKOdBAgfMnalCMhw2RkBeQAZxjPT3pNTOgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(412 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW22NyQ0AIAzD3I4KczGreRVxRcrHjhRoqrI3+SQBouMBHcQtEqDEASu1XnBfP+/RcQKavRjGL3PgMAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(398 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAe0lEQVQ4T52SQQ7AIAgEF9OXtu/qW+mh2YYqCjJH3UxWQVQVu8gFBQC9Ifb88OM+lEzvM81WEttuKYuaEArbLJAVWYZmFQnwtvsGUJVYBGdiAkm2VmNGOIAsw2pU/qvffqDwTE9CWhSwRLlUs0hCfkvb/11WQtxmuxLyAMz2NejKo2qaAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(398 617)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVQ4T52SQQ6AMAgEl0b9qT7Kp3rBg8HQlhbKHBsy2cISM2OV4wIDwHOD9Ptmj9uIZARFks0kOt1U5iURRFhGA1GRpkuWkQBfuv8AWYmG9jNwgSBL1RjhHiBKV43Mvtr2A4lvWhKheAMaby6UzJMIVWnb3UUlgplsVSK8+4c10Eqd9NYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(398 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW13KQQoAIRADwTagP9VH7VP3Ek8j0YaBIRR92rbJE8BYmEj/R+NJ9aQWwKtFVPqMqS9ZegPgpxjWGWi8pgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(384 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ6AMAgEl8b6U32UT/WyHkwbWlFo4yRcKJlQskISo6w7CADnAdF9GZEViUYLl/7RwpJYJG/AE+n31808icXjZjMS4L5d3WxWohGSv4gAQPI2kI0Pmm/OonM2/c0+/UAwtBpLUkjegMabC23mSQpNaPvbRSUVkk3ljex70boAY4JtrFm3DDgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(384 625)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ6AIAwEt8QTvlQf5E89rwcDKVhtIU7SS2kmpVkhiVHWHQSA84DovozIikSjhUv/aGFJLJI34In0++tmnsTicbMZCXDfrm42K9EIyV9EACB5G8jGB803Z9E5m/5mn34gGFqNJSkkb0DjzYU28ySFJrT97aKSCsmm8kb2vWhd8Fltvk/Ar5YAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(384 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW12NQQoAIAzDsh71pfogf+q5nobTQGGU0NGGbZsaAfSJKWgvgg/lUW0B/LYopB32/ZHlY+bMAV2CG+SXNHwdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-6)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(370 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiElEQVQ4T62SSw6AIAwFp8SVnlQP5E1Z14XBFC3fOEsKk7Y8UVVG2Q4UIJ6IPZcRWZJYrHB5Fz08iUdoXWiJbL3YWUvi8dnZjATu3T2yWYklwD8iAFn3gWxUiCfSFY0aNmeiqlNjvtMPHTnz8ERgotHTXUmSyHJWErYkieoH9EoS2c7s41ERwAW31Tt9krezkQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(370 633)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQ4T62S3Q2AIAwGr8QBdE+dxkEZoT4YTNHyG++RwqUtn6gqo2wHChBPxJ7LiCxJLFa4vIsensQjtC60RLZe7Kwl8fjsbEYC9+4e2azEEuAfEYCs+0A2KsQT6YpGDZszUdWpMd/ph46ceXgiMNHo6a4kSWQ5KwlbkkT1A3oliWxn9vGoCOACVpM7htbSFKUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(370 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz05g99RpHNQR4itSPQiU5Ch9SJKoCYCciELsReMjfFQ7AGx7uGZ9c0uTEz2l7QNaBxp9mmUCYwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-8)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(356 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU3Q2AIAwGr4YBdE+dhkEZob5IUgk/rd4jJUchXxFVJcpxoQAlI3ZdIrIqsVjh1hZH9EQty848ktrdUOaRWEpGUrsYlVhenf0RAST4L6nIfgayMaH7ZlFszkRVP12zTT88oe0VZoz2h665OtQVjZWkspxNrwg64zT6XjzcHcY+iLkUDUEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(356 641)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU3Q2AIAwGr4YVdE0dhTlZor5IUgk/rd4jJUchXxFVJcpxoQAlI3ZdIrIqsVjh1hZH9EQty848ktrdUOaRWEpGUrsYlVhenf0RAST4L6nIfgayMaH7ZlFszkRVP12zTT88oe0VZoz2h665OtQVjZWkspxNrwg64zT6XjzcXJk+gIae2IIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(356 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12KsQ0AIAzDTH+AN+EU7uSJMAW1RMpimz4lSeQHwFiItDib9osAsCjQc/1grkvpukDXF6BcGoU83G4KAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-10)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(342 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU0Q3AIAhEj8YV2jXbUZzTJa4fDQk1UMW+TzQvYA6FJLIcFwgArUJsXTIylViscOsPIzxRXy/eBUsk8QjHzEiAZ1x3zKxIeXW2KlEK8F+iyH4msvFBqxAh+auzpZx5hBuQ6a6XKMPQWiKJMhWNkUQZvtmsCHDWKfpeZrgBHEY+kpxsXeMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-11)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(342 649)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WU0Q3AIAhEj8Yp2i3bORzTOa4fDQk1UMW+TzQvYA6FJLIcFwgArUJsXTIylViscOsPIzxRXy/eBUsk8QjHzEiAZ1x3zKxIeXW2KlEK8F+iyH4msvFBqxAh+auzpZx5hBuQ6a6XKMPQWiKJMhWNkUQZvtmsCHDWKfpeZrgBsd0+qjiv79QAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(342 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12NwQ0AIAjEqmPIljKHYzrH+REj9HU0TWhjSgB70bj0/3gyhjlKstadj6ifTI8omKMkoz6Kxg6AwHBi6AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-12)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(328 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T6WT0Q2AIAxEr4YpdEudgzGZo36YM5VQoPK+SCgvVwqiqohyXHgPlQzhemuX+1hRjcwm60mYLnkFpCepcZNFJMCTrnlnURH5JPsrIQlYlxDZz8lxDigZIqq6lGzp0VqsCDADiKSrJWT4aC2ehLxtjgpH+0DjB9TtzkiI22ZEQm7JxzoJmU9N7wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-13)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(328 657)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T6WT0Q2AIAxEr4Y9dEqdgS3ZpH6YM5VQoPK+SCgvVwqiqohyXHgPlQzhemuX+1hRjcwm60mYLnkFpCepcZNFJMCTrnlnURH5JPsrIQlYlxDZz8lxDigZIqq6lGzp0VqsCDADiKSrJWT4aC2ehLxtjgpH+0DjB9TtzkiI22ZEQm5ExzoJ1mFIlwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(328 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12MsREAIAjEgovolDqDW7rJ2wgHpoJcwPqUAM7GeLS8hPRhLFTkXzcSXpsUVyFL6W+KdC43XBAJ1fTySwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-14)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(315 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WSwRGAIAwEL459aJVaA13SCX48hokED90Xj7CTXGKlFMywn6gfcoLxvfTL+7QSjykdjQTsao0KgLHAE46mSlj3GE0VeOpoXwXEtkNIW2Bq/RE5wX6LpPWPaK8auLc2E7QXkLr+N1kkIFJGbxLAHaTvShGQbtgzAnIBfJg0OenSruAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-15)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(315 665)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WSwRGAIAwEL46laJFaAE1SDH48hokED90Xj7CTXGKlFMywn6gfcoLxvfTL+7QSjykdjQTsao0KgLHAE46mSlj3GE0VeOpoXwXEtkNIW2Bq/RE5wX6LpPWPaK8auLc2E7QXkLr+N1kkIFJGbxLAHaTvShGQbtgzAnIBBJk0SQHk8K8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(315 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW22NsQ0AIAzDTG+BI+kBPMkxYSqiQKQsdqRQuySJs8YnBtAcJTgH5RYGECLBSKw3PNfPe3O0AM25GTxv/3OKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-16)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(301 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8ZRdEgdwCUdBj8Mhra0UN5nQ16ucMTMWOW4wADw3CD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9DFwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC8khDU35o/ODwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-17)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(301 673)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52SQQ6AMAgEl8bP6Bv15B/9Dh4Mhra0UObYkMkWlpgZqxwXGACeG6TfN3vcRiQjKJJsJtHppjIviSDCMhqIijRdsowE+NL9B8hKNLSfgQsEWarGCPcAUbpqZPbVth9IfNOSCMUb0HhzoWSeRKhK2+4uKhHMZKsS4QVTFTUfIOHfXQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(301 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW13KwQkAIRBD0W+60Rr1tD1uO/E0Ev0wMIRHn7Zt8gQwFibS/9F4Uj2pBfBqEZU+Y+pLlt4TshlMVmb5VgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-18)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(287 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAh0lEQVQ4T62SQQ6AMAgEl8bP1DfqyT/6nfVg2tCKQhsn4ULJhJIVkhhl3UEAOA+I7suIrEg0Wrj0jxaWxCJ5A55Iv79u5kksHjebkQD37epmsxKNkPxFBACSt4FsfNB8cxads+lv9ukHgqHVWJJC8gY03lxoM09SaELb3y4qqZBsKm9k34vWBf7+biLcajJbAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-19)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(287 681)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62SQQ7AIAgEF9P/2B/WJ/ZH20OjQUsLmk7CBckEyQpJzLIXEADOAtF9mZFViUYLt/HRwpJYJG/AE+n31808icXjZisS4L5d22xVohGSv4gAQPIxkY0Pum+uonO2/M0x/UAwtBpLUknegMabC23mSSpdaMfbRSUNkl3lgxx70boAi+ZuNMg4FtEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(287 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQIW12NwQkAIAwDr1lIN7QjulF8FasHgRKOlLFs2/QIYCamoZ0EH6qj2wL4bdEoO+z7o8rHrJkDnAYcWhaPDkEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-20)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(273 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAh0lEQVQ4T62SSw6AIAwFp8b76A3liNyoLgymYPnGWVKYtOWJqjLLGVCAGBB7LjOyJLFY4V4WPTyJx9a70BPZerWznsTjs7MVCTy7e2WrEssG/4gA5LgmstEgBmQoGi1szkRVl8Ys0w8DOfPwRGCiMdJdTZLIclYT9iSJ5geMShLZzuzjWRHADchRO7i9KjJ6AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-21)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(273 689)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62SSw7AIAgFB9Mr9XYuezsPRReNDbX4jbMUnQA+UVVmOS8UIEXEnsuMLEssVniURQ9P4hF6F3oiW6921pN4/Ha2IoFnd69sVWIJsEcEEHaJUkSGotHC5kxUdWnMMv0wkDMPTwQmGiPd1SSZT85qwp4k0/yAUUnmszP7eFYEcAMLijrF4vT/KwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(273 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz85kt/On2zlUfEWqB4GSHKVPSRI1AZALUYg9aHyEj2oHgG0P16xvbmlyoae0fQCQGRq4KaWHHQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-22)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(259 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+NK3c5nt3Mo+qkJNVqh9p5gTjCgqCpRjhMFqAWxcYnImsRihalPzhiJepaVeSStuqnMI7HUguQ+GJVYHpXtiAAy7Esa6S/R8M2i2DkTVf3UZj/9cA/tKPHG7HyozdWlrtFYSRrL3fSKYLBOs+/FwwWRpj1RLfDqigAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-23)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(259 697)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+NU3cwJuplr0U9NqNEKtfcEc4IBRVWJcpwoQC2IjUtE1iQWK0x9csZI1LOszCNp1U1lHomlFiT3wajE8qhsRwSQYV/SSH+Jhm8Wxc6ZqOqnNvvph3toR4k3ZudDba4udY3GStJY7qZXBIN1mn0vHi7QeT1JFgA9ngAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(259 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12KsQ0AIAzDTL+Cz3gAPuOtMAW1RMpim74kSeQHwNiItDiT9osAsCjQc/1grkvpukDXF9ZuGsBmSXR4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-24)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(245 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62U0Q3AIAhED+NU3cwJuplrXT8aEmogivZ9onkBcygkkeW6QQDoDWLrkpGpxGKFZTyM8ERjvXoXLJHEIxwzIwHecd0xsyLl09muRKnAuUQpf4l6gwjJo862cuYRbkCmu1GiTENriSTKUjRmEmX6ZqsiwFmn6HtZ4QEQNT5H6wcOUAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-25)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(245 705)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62U0Q3AIAhED+Ne3cohupWTXT8aEmogivZ9onkBcygkkeW6QQDoDWLrkpGpxGKFZTyM8ERjvXoXLJHEIxwzIwHecd0xsyLl09muRKnAuUQpf4l6gwjJo862cuYRbkCmu1GiTENriSTKUjRmEmX6ZqsiwFmn6HtZ4QGlzD5feNEAjwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(245 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12NwQ0AIAjEKoPpVu4gWznZ+RED9nU0TWh9SQB70rhYPp6MMRwV+ddGIuonyyM+hqMioz520A5FI5WFaAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-26)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(231 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T62T0Q3AIAhEj8a9upVDdCsnox/NGWpEpfZ9mYgvh6KoKqKcF+qhkiFcH/1yHytqkdVkIwnTJa+AjCQtbrKIBHjSde8sKiKvZF8lJAH7EnL8JSoZIqq6lWxraC1WBJgHiKRrJWQ6tBZPQmqbs8LZPtD5AW27KxLithmRkBuUYzkNzMPF6gAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-27)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(231 713)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T62T0Q3AIAhEj8bRupFzdCN3ox/NGWpEpfZ9mYgvh6KoKqKcF+qhkiFcH/1yHytqkdVkIwnTJa+AjCQtbrKIBHjSde8sKiKvZF8lJAH7EnL8JSoZIqq6lWxraC1WBJgHiKRrJWQ6tBZPQmqbs8LZPtD5AW27KxLithmRkBsBujkNpqthLQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(231 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQIW12MsREAIAjEgqvpRq6hG7nb2wgHpoJcwPqSAM7EeLS8hPRhbFTkXzcSXpsUVyFL6W+KdC4wyhAJfDhffAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-28)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(218 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSwRHAIAgEj4ylpSPrSEf2Zj45x0FRiPvygTvAIbVWRLgftA8lQ/i+5uVzeolGPB2tBOwqWQXAWqAxR/NKWDeM5hVo2mh/BSSdCkgofouSIcciV/wr+qsGvtQie9IC0uLfySwBce1oJwHUQequPAIyXXZEQF7XoTOzyj6GnwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-29)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(218 721)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfElEQVQ4T6WSwRHAIAgEj4zNpRprSTWWZz45x0FRiPvygTvAIbVWRLgftA8lQ/i+5uVzeolGPB2tBOwqWQXAWqAxR/NKWDeM5hVo2mh/BSSdCkgofouSIcciV/wr+qsGvtQie9IC0uLfySwBce1oJwHUQequPAIyXXZEQF5wnzPFUwUfFgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(218 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW22NyQ0AIAzDTKej07AKTMN44VVUjkj52JFC7ZIkco1PDMAHOuBslFsYQIgDRmK9YV4/7z7QAgDEGbL3Q18bAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-30)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(204 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8bhdBpX0WkcDz8Mhra0UN5nQ16ucMTMWOW4wQDwnCD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9ClwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC98AzSGrOWZawAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-31)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(204 729)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T52S0Q2AMAhEj8b5dBG30UWcED8Mhra0UN5nQ16ucMTMWOW4wQDwnCD9vtnjNiIZQZFkM4lON5V5SQQRltFAVKTpkmUkwJfuP0BWoqH9ClwgyFI1RrgHiNJVI7Ovtv1A4puWRCjegMabCyXzJEJV2nZ3UYlgJluVCC+wZTRrp0g7RQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(204 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQIW13K0QkAIRAD0TEFaiN24zVyFcavlejAwhIefdm2yRPA+DCR/knjSfWkFsCrRVT6jKkvWXoDR4wZxOG4ZqgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-32)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(190 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T62S0Q2AMAgFH43z6SJuo4s44fPD1FDEQJtewg+QCxCEJHrZThAArh2i89IjqxKNFi626OFJPErUEIl0/XeySOLxudmIBHhu9042KtEIySkiACizRM2ao+g/G17Tfj+QfFqNJ6mUqEET9aUmiySV5mnt7bKSF5JNrAdpc9m4AU6sbZ5q9kruAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-33)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(190 737)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T62S0Q2AMAgFH40b6hIupEu44/PD1FDEQJtewg+QCxCEJHrZThAArh2i89IjqxKNFi626OFJPErUEIl0/XeySOLxudmIBHhu9042KtEIySkiACizRM2ao+g/G17Tfj+QfFqNJ6mUqEET9aUmiySV5mnt7bKSF5JNrAdpc9m4Acveba417E+CAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(190 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12NwQkAIAwDr1lRl3AhXcId46tYPQiUcKS0adumRgB9YQrag+BDeVRbAL8tCmmHfX9k+Zg5cwDaiBzQhMcu8AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-34)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(176 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62S3Q3AIAgGD9MRu4QTdQl3pA+NDbX4G+9R9AL4iaoyy3mhACki9lxmZFliscKjLHp4Eo/Qu9AT2Xq1s57E47ezFQk8u3tlqxJLgD0igLBLlCIyFI0WNmeiqktjlumHgZx5eCIw0RjpribJfHJWE/YkmeYHjEoyn53Zx7MigBt9SDr3geCsOQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-35)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(176 745)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhUlEQVQ4T62S3Q3AIAgGD9Mlu4BDdQHHpA+NDbX4G+9R9AL4iaoyy3mhACki9lxmZFliscKjLHp4Eo/Qu9AT2Xq1s57E47ezFQk8u3tlqxJLgD0igLBLlCIyFI0WNmeiqktjlumHgZx5eCIw0RjpribJfHJWE/YkmeYHjEoyn53Zx7MigBsKZDr/bVjn/wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(176 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPUlEQVQIW12MwQkAIAwDz05pF3AnXcAx4ytSPQiU5Ch9SpKoCYBciELsQeMjfFQ7AGx7uGZ9c0uTCz2l7QPFQRryyo9D+AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(162 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T62UwQ3AIAgAD+OSXcChuoBj0k9NqNEKtfcEc4IBRVWJcpwoQC2IjUtE1iQWK0x9csZI1LOszCNp1U1lHomlFiT3wajE8qhsRwSQYV/SSH+Jhm8Wxc6ZqOqnNvvph3toR4k3ZudDba4udY3GStJY7qZXBIN1mn0vHi5ZPj0XhHWjCwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-37)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(162 753)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVQ4T62UMQ7AIAgAD+M7O/iwDn6ULjWhRivU3gjmBAOKqhLlOFGAWhAbl4isSSxWmPrkjJGoZ1mZR9Kqm8o8EkstSO6DUYnlUdmOCCDDvqSR/hIN3yyKnTNR1U9t9tMP99COEm/MzofaXF3qGo2VpLHcTa8IBus0+148XJ/sPQ5VDtx8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(162 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW12KsQ0AIAzDTP+Egb9g4NEwBbVEymKbviRJ5AfA2Ii0OJP2iwCwKNBz/WCuS+m6QNcXDI8a+73Xk4YAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-38)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(148 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfklEQVQ4T62UQQ7AIAgEF+M7e/BhPfjR7aEhoQaiaOeIZgJmUUgiy3WDANAbxNYlI1OJxQrLeBjhicZ69S5YIolHOGZGArzjumNmRcqns12JUoFziVL+EvUGEZJHnW3lzCPcgEx3o0SZhtYSSZSlaMwkyvTNVkWAs07R97LCA1+oPvjGQ0E8AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-39)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(148 761)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhklEQVQ4T62UwQ3AIAhFP62LdDIPLtJFPHS2DkIPDQk1EEX7jmhewHwkZkaUcoEBoGaQrlNEJhKNFm7toYclauvJuqDxJBbumBEJ8I5rjhkVCZ/OZiVCAtYlwn4f5y+imkHEzEudTeXMwt2ASHetROiGVuNJhKFo9CRC981GRYCxTt73MsIDKsU/kSq40GAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(148 769)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW12NwQkAIAzEYhcVdC7BTnp+rNjmdQ2BtrElgNVpXOw/nowxHSVZa+Mj6ifTIwrTUZJRH2LaDgo5RZMHAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-40)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(134 769)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAiUlEQVQ4T62TwQ2AIAxFf9VFnIyDi7iIB2dzkHow31RChYrvREJ5+YUiqoooy4770JYgXA/lch8rypHWZG8Sppu8AvImyXGTRSTAla54Z1EReST7KiET0C8h4zGvv4i2BBFV7UrWNbQWKwLMA0TS5RJSHVqLJyF3m7XC2j5Q+AF5uy0S4rYZkZAT7/o5jjH/r8IAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-41)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(134 768)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN1enBlSkAX3mvtxkdojl3i/Wi4S5OyK1wwGgFRgOeVYLtcNHsIpFs+ywYvqFqRZZ6LLMFdml5u6yFcOWx2YRbtJzaxUZGb/KZOTRUDD+AcBdaCuwaQNagSlDyqTdVAPHvu1onFhO3yyD3zNetDVjMtMXLMJEDa+ZJIwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(134 768)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW23KwQ0AIAzDQLdzsgATsUD3DK8givDTupDE3SyUfGpzFmrTYw2iyTWII63ckVYA+SqADRqWECUVwCw/AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-42)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdQxGaCdiAHKnunLEkqBmHtWwb3E5u4gT4cDQKswHFJmH58OZ6iK0Wj3UDGcGkUUw8LB3RDZzdn9uhQSietKq82I6167YQWGFaURhQJo9WaYh1urDUZ+QeQksFXYMohkgTxLWr96v9RoJNqNP0mNRlqFrQw/do0+Q0Jl4UYAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-43)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdQlGaIdhiHKmOnLEkqBmHtWwb3E5u4gT4cDQKswHFJmH58OZ6iK0Wj3UDGcGkUUw8LB3RDZzdn9uhQSietKq82I6167YQWGFaURhQJo9WaYh1urDUZ+QeQksFXYMohkgTxLWr96v9RoJNqNP0mNRlqFrQw/TX0+a4AUFc4AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(121 760)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPklEQVQIW2XKQQ0AIAzF0A7EoAkTaEADJnCHhc+JZRk9Ns8k8RobARRSq2M+n/rk6pjPqADqaVNRuYzDZ+4Cf98PjumwV5IAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-44)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhED7d0iDqMQ9Qxr182xBQB+/6IEd6BkMSkDbxFrxAkKdaDbhxFptnuc9TSNNO0AUZMhWQ6kmUaMluxhst1M2W1oi2PzDR6n0c7syhA/PQ7eoUUXfxtKjT2n4k+JcwDnJi61/Qa6ncz5hdr9HWQa6bxoj86tDzJ0jTAugAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-45)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhED3d0kTqHi9Qhr182xBQB+/6IEd6BkMSkDbxFrxAkKdaDbhxFptnuc9TSNNO0AUZMhWQ6kmUaMluxhst1M2W1oi2PzDR6n0c7syhA/PQ7eoUUXfxtKjT2n4k+JcwDnJi61/Qa6ncz5hdr9HWQa6bxoj+lczyufQ+ragAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(107 752)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW2XKQRHAIAwAwQ0eUVIdKKnI8EqG0nvebGSm6nklDFdrip6lfnJN0fNUH1kKxq1ango2JaQPDXOwQYsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-46)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd69HGrnUQSOhyL0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6AQ+KRXFet+DaAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-47)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd69EmrmUQDOhxb0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6ActmRZFgXwSMAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(93 744)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW13KQREAMAjEwIBE1FQCamrx+oKh5JlZk8TsXOR7APgeGdgnM7CWpaqWpQB8q5ZTATwp+xEyj/4P5AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-48)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T52UwRHAIAgED0u0mpRgNbZ4eZm5OBIg+9ZjFdRIQrkmCACjw1DENGwFKZXQFi04FfB4zDKbIksjmQpSvNDwmCeuCZ4EWtVK2ff+MlPU8tedeYRzVuF1zKj1X4wOs/05LSqWS8JtwOiwqqlrtuOZasH0aGQs02aK903dUz5Hkc4uNVgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-49)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T52UwRHAIAgEDxu0orysyAovLzMXRwJk33qsghpJKNcEAWB0GIqYhq0gpRLaogWnAh6PWWZTZGkkU0GKFxoe88Q1wZNAq1op+95fZopa/rozj3DOKryOGbX+i9Fhtj+nRcVySbgNGB1WNXXNdjxTLZgejYxl2kzxvqkb9MpHsVvTab0AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(79 736)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW13LsRHAMAgEwUUNqiJHqsgV4ggN+MOdv8hMfc8r1x9gIJwtLtbrPgvOFiMvgNWzkfcXfPLBEToy4kOZAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-50)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3EMAgEhzToivJyRamQezlaOURAbr62BxZhc3eU88IB5sBoYipbIqUjPbIL54VHRSJuWfYgO4dCZ0rWpbl7qWrEPs/jqwie0VsxIzT6XzF30j3rYPsPgG/SObBwZp2tV8LOlEqXq3gqW7xJNUV5NebAsvhl2UKFu/wHWslIPL6w6fcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-51)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3EMAgEh9TnmvxITemPezlaOURAbr62BxZhc3eU88IB5sBoYipbIqUjPbIL54VHRSJuWfYgO4dCZ0rWpbl7qWrEPs/jqwie0VsxIzT6XzF30j3rYPsPgG/SObBwZp2tV8LOlEqXq3gqW7xJNUV5NebAsvhl2UKFu/wHewtIdDE6A9IAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(65 728)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAPElEQVQIW2XKwQ2AMAwAMaesxBidqULMxH7hRRTgntZFZuqdlxxfgBfCmqLwuX7nmqKwX7CN/ch+1dkBbqbAEMOJ8S79AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-52)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4T6WTwQ3AIAwDnc7HTDyYif3cF1VkRYTQ+wLOEYKRhGdMEAB6g6GI+bAV5KmEPtmGMcGoSMQXlh3I1oEDM09maSSPqkZoP0tmipo+t1aelfHrmko6ZxVMfwBwF9obLHyA3mCVyV9sX/M0cO1LR6NiGfZsh/bTF0rNFH9YjV8wvUTZLi9QzAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-53)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T6WTwQ3AIAwDnU7HSIzASGznvqgiKyKE3hdwjhCMJDxjggDQGwxFzIetIE8l9Mk2jAlGRSK+sOxAtg4cmHkySyN5VDVC+1kyU9T0ubXyrIxf11TSOatg+gOAu9DeYOED9AarTP5i+5qngWtfOhoVy7BnO7SfvlBqpvjDavwCbm5FAWM+xNwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(51 720)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW2XKOREAIBDAwD3UIQkJSMLdUcHwpMxsZKazPmR5B1wTWhV7LvXJVsWep7rkUlBeBROKcBCL4aY5zgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-54)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN1edkpSgJN3tfbnJ7BDh3i/Wi4SRhKd1EABqgeGQZ7XQOjiCs5g3iw5nTL+wrEUUuixzRXSpkUxbKWp5bObRJj23Vp6R8atMJT0aGUx/AHAXWgts2oBaYJkhVcJuZgPHvu1onFhO3yxC39NftDVTItMXdwJEQOvj2eMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-55)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgElEQVQ4T6WT0REAEQxEN9ebitShIsXtfbnJ7BDh3i/Wi4SRhKd1EABqgeGQZ7XQOjiCs5g3iw5nTL+wrEUUuixzRXSpkUxbKWp5bObRJj23Vp6R8atMJT0aGUx/AHAXWgts2oBaYJkhVcJuZgPHvu1onFhO3yxC39NftDVTItMXI05ESLhBIZ8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(37 712)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOUlEQVQIW23KwQ0AIAzDQLe7MRFzMFGHC68givDTupDE3SqUfGpzFWrTYw6iyTmII63ckVYA+SqADVMaEJscxlVcAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-56)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdTVmIg1ykJluPRlCaVA3HtWwb3E5u4gfcABoFUYflJWH/uAM1TFaHR6qBgujSKKYeHgaYic5ux+XAqJxHWl1VbEda/TsALDitKIQgG0ejPMw63VBiOfIPInsFXYNohkgTxLWr96v9RoJtrNP0mNZlqF7Qxfp54/ak8H7RcAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-57)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 18,
    height: 16,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T5WRwQ3AIAwDHdTJGIhdyj5ltfRlCaVA3HtWwb3E5u4gfcABoFUYflJWH/uAM1TFaHR6qBgujSKKYeHgaYic5ux+XAqJxHWl1VbEda/TsALDitKIQgG0ejPMw63VBiOfIPInsFXYNohkgTxLWr96v9RoJtrNP0mNZlqF7Qxffo4/kulAuGUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(24 704)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAN0lEQVQIW2XKQQ0AMAjF0II0BCFmgmbt7wQhrMeXmiSqcxGAs8rAGuv6zgyscV4AXlBXnxMadw94LA8NAkRlXwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-58)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhEwdEcyF3qPnW165cNMT0B+/6IEd6BApBJH/IWrYpKksIebOMoOs12n6OW1MzShyBiqgDSkZhpyGyFDdfrRspqxVoemVnsPo92xigi8dPvaFW02OJvUwXZfyb6lKAHODF1r+k1tO805hdr9HWQa2bxoj/2kDwYiCNvlAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-59)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4T6WR0Q3AIAhEwcWcx4XqOnWy65cNMT0B+/6IEd6BApBJH/IWrYpKksIebOMoOs12n6OW1MzShyBiqgDSkZhpyGyFDdfrRspqxVoemVnsPo92xigi8dPvaFW02OJvUwXZfyb6lKAHODF1r+k1tO805hdr9HWQa2bxoj9VgDwAcXeIpAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 8,
    transform: "translate(10 696)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAsSAAALEgHS3X78AAAAOElEQVQIW2XKQRHAIAwAwQ3G0IOi6qmy8EqG0nvebGSm6nklDFdrip6lfnJN0fNUH1kKxq1ango2PEwPDeYK8vMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip-path-60)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 19,
    height: 16,
    transform: "translate(-4 688)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAhElEQVQ4T6WUwQ3EIAwEd68x6qGhSzuhsr0XkmNpI5ubFzxsxsZASYhcCwKAOUA0+cTNTpTXVbjN3oKrlg8zx7WgiikltUtypiWzjDuc31stq0y0PDKLxH4e9czBOLT/JJ0DfJRZnScH83PadCy3hL2AOcCuqTXLONOj0ahYls0i7pv6AWHPRlkBO2yyAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-67",
    d: "M292.91 588v-1.74a3.61 3.61 0 01-2.12 3 11.33 11.33 0 01-10.27 0 3.59 3.59 0 01-2.13-3V588a3.6 3.6 0 002.13 3 11.33 11.33 0 0010.27 0 3.61 3.61 0 002.12-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-68",
    d: "M291.38 565.4a2.86 2.86 0 00-1.68-2.34 9 9 0 00-8.1 0 2.86 2.86 0 00-1.68 2.34l-1.53 20.84a3.58 3.58 0 002.12 3 11.33 11.33 0 0010.27 0 3.61 3.61 0 002.12-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-69",
    d: "M289.19 558.16c-2.38-1.42-8-1.25-8.54 2V566c.53 3.29 6.15 3.46 8.54 2a2.48 2.48 0 001.47-2v-5.8a2.48 2.48 0 00-1.47-2.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-68",
    d: "M289.78 574.37l.73-6.78a2.47 2.47 0 00-1.66-2.61l-1.78-.62a4.42 4.42 0 00-2.83 0l-1.81.62a2.48 2.48 0 00-1.66 2.62l.75 6.77M334.63 562.08l-13.05-11-7-3.87a9.21 9.21 0 00-8 .12 3.41 3.41 0 00-1.7 2.94v5.48a2.88 2.88 0 001.7 2.36l8.63 5.53 7.53 4.81c.16.11.32.22.5.32 3.35 2.05 11.71 1.78 12.35-2.95v-1.67a2.64 2.64 0 00-.96-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-69",
    d: "M314.45 542.54c-2.39-1.43-8-1.25-8.54 2v5.78c.53 3.29 6.15 3.46 8.54 2a2.49 2.49 0 001.47-2v-5.78a2.48 2.48 0 00-1.47-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-68",
    d: "M313.13 554.42l-1.41-1.28a1.17 1.17 0 010-1.77l3.57-2.86c.39-.31-.41.27 0 0 1-.84 2.78-1.7 4-.14.09.12 2.4 2.93 2.23 2.72l13.13 11c1.11.83.94 2.47.93 3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-67",
    d: "M304.93 557.18a2.91 2.91 0 001.7 2.38c4.29 2.73 12.4 7.93 16.66 10.66a11.31 11.31 0 0010.23 0 3.61 3.61 0 002.12-3v-1.52a3.59 3.59 0 01-2.12 2.95 11.31 11.31 0 01-10.23 0L306.63 558a2.9 2.9 0 01-1.7-2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M321.27 425.43c-6.12-3.5-15.32-3.53-21.52-.16-3.36 1.9-5.09 4.53-4.56 7.31.08.23 6.23 56.22 6.49 57.74-1.1 12.22-3.72 40.58.63 51.66.25.64.42 1.3.61 2 1.06 3.71 7.79 4.19 11 3.16 2.29-.66 4-2.17 4.06-4.68 0-.19 4.72-40.33 4.82-41.28 0 .1 1-7.3 1.06-8.92.19-3.64.58-11 1-19.15.83-15.72.87-27.75.87-27.75.21-2.44-1.37-17.81-4.46-19.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-70",
    d: "M302.87 458.5c.16-2.39.45-17.76-2.64-19.88-6.12-3.5-16.26-3.53-22.45-.16-3.36 1.89-5.09 4.53-4.56 7.31.08.23 3.33 43 3.59 44.51L278 558.1c.17 4.52 7.69 5.16 11.18 4 2.29-.66 4-2.17 4.06-4.68 0-.19 3.78-40.33 3.88-41.28l2.07-28.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-71",
    d: "M326.07 368.65c2.6-1.75 1.91-4.45.77-6.5-2-4.25-8.61-3.86-8.61-9.69.25-4.91-4.56-4-4.56-4l-8.75 7.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M329 430.49s2.94 12.21-2.18 13.56a2.91 2.91 0 01-3.64-1.79l.22-10.51a5.94 5.94 0 005.6-1.26l1.26-35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M323.44 431.75l-2.18-36.39s4.82 2.08 9 .17l-1.26 35a6.52 6.52 0 01-5.56 1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.85 454.1c11.47 6.13 28 3.91 38.55-2.14 5.29-3 8-7.51 7.85-11.08-.67-4.64-3.29-23.3-3.2-22.69.17-4.64.64-17.18.82-21.82h.11a12.93 12.93 0 006.58-.73c4.21-2.1 2.14-10.37 2.35-14.46-.56-14.87-14.41-21-27.4-24.94l-17.32 3.92C255.78 385.34 260.25 391 259.73 411c-.13 7.38 6.39 10.22 12.66 7.78l.37 5.11c0 .08-.64 8.06-1 12.94-.17 2.16-.29 3.71-.28 3.72-.01 4.11 3.02 10.7 8.37 13.55z",
    fill: "#0058a1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M288.78 359.06c-2.06 2-1.41 4.2 2 6.15a33.51 33.51 0 007.43 3.24c2.81.77 5.63.93 7.77-.31 4.44-2.56 4.05-9.69-.44-11.93v-15a3.61 3.61 0 00-2.13-3c-2-1.24-5.84-1.63-8.73-.73-1.93.6-3.44 1.79-3.7 3.7v13.8a7.63 7.63 0 01-2.2 4.08z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 23,
    height: 33,
    transform: "translate(287 337)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: 'multiply'
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M335.53 451.85l5.41-64.14 21.45-19.02-5.39 63.99-21.47 19.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-75",
    d: "M362.39 368.69L357 432.68l21.95-11.52 5.42-64.2-21.98 11.73zM316.52 396.04l24.42-8.33-5.41 64.14-24.48 8.34 5.47-64.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M262.58 430.46l-.9-13.44c3.83 4.23 11.71 2.5 14-.5v8.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-76",
    d: "M261.68 417c2.88 3.18 8.1 3.11 11.68 1.29 4.12-2 3.69-5.44 3.56-9.35 2.22 0 1.87 2.61 1.86 4.09a7.08 7.08 0 01-.75 3.25 2.26 2.26 0 00-.49 1.24v4.14c0 .38.17 1.38-.07 1.59s-1.39.14-1.78.18v-4.4c-3.58 2.91-13.35 4.27-14.01-2.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575757",
    opacity: 0.2,
    d: "M381.89 392l-.81-1.68-20.41 9.93 2.7-32.08-.98.52-1.01.89-2.68 31.79-19.5 18.03 2.75-32.59-1.01.9-.97.33-2.78 32.97-23.77 7.31.54 1.78 23.06-7.09-2.46 29.17.97-.33 1.01-.9 2.43-28.8 19.5-18.03-2.48 29.47 1.01-.91.98-.51 2.5-29.76L381.89 392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M384.28 397.47l-2.28 1.35a2.67 2.67 0 01-3.52-.82c-2.24-3.57-3-9.46 1.06-11.93l1.53-.88.6-.36a3.56 3.56 0 015.23 3.11v5.1a5.33 5.33 0 01-2.62 4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-76",
    d: "M311.48 455.09c.41-4.9 1.57-18.27 2-23.49 5.37.82 11.31-.19 11.28-6.91-.37.69-.28 1.62-.6 2.34-.69 1.52-2.8 2.23-4.27 2.54-3.7 1-7.45-.58-11.13.24a83.69 83.69 0 00-11.21 1.74l-25.79 4.88-.15 1.93 32.8-6.22c2.4-.29 4.84-.53 7.21-.74l-1.89 22.27-.18 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-72",
    d: "M313.2 429.69c-2.37-.63-4.6.4-6.63.31a6.56 6.56 0 00-1.4.11l-34.51 6.53c-3.48.57-7.61-3.23-8.08-6.18s3.13-6 6.78-6.37l36.24-3.69c2.62-1.45 6.5-3.09 7.77-3.23 3.75-.5 9.49.69 10.88 4.76 3.41 9.98-11.05 7.76-11.05 7.76zM299.68 318.62a16.25 16.25 0 00-16.24 16.25v10c.85 21.54 31.63 21.54 32.48 0v-10a16.25 16.25 0 00-16.24-16.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-71",
    d: "M315 324.93c-4.52-5.64-13.28-9.63-20.3-7.47-6.92-1-18.65 0-19.6 17.11 0 4.72.24 10.61-1.08 15.14a8.82 8.82 0 01-5.29 6 8.81 8.81 0 00-5.56 8.2c0 2.06 1.24 6.82-2.05 7.79-13.48 3.51-11.47 31.57-1.29 33.75 0-15.71-.78-22.55 28-45a4.11 4.11 0 011-1.36 9.6 9.6 0 001.05-1.32 17.29 17.29 0 01-5.74-9 16.54 16.54 0 01-.54-2.92c0-.27-.18-.6.09-.42 2 .76 5.54.67 5.3-5.07.12-4.74 1.43-6.65 3.69-7.23 4.74-.82 11.6 2.88 16.3 2.45 1.26-.07 7.49-.48 7.54-3.15s.15-5.43-1.52-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6 271.56v-13.12q6.57-.26 10.25-3a9 9 0 003.69-7.74v-1.13a8.2 8.2 0 00-2.47-6.28 9.17 9.17 0 00-6.52-2.31 9.75 9.75 0 00-7.05 2.56 13.06 13.06 0 00-3.65 6.44l-6.72-2.6a20.18 20.18 0 012.15-4.94 16.59 16.59 0 018.66-7.09 19.93 19.93 0 016.85-1.09 21 21 0 016.92 1.09 14.83 14.83 0 015.31 3.16 14 14 0 013.36 4.94 16.75 16.75 0 011.18 6.36 16.23 16.23 0 01-1.3 6.69 15.49 15.49 0 01-3.36 4.86 17.78 17.78 0 01-4.74 3.24 22.13 22.13 0 01-5.35 1.74v8.18zm3.49 18.22a4.67 4.67 0 01-5.35-5v-1.21a5.35 5.35 0 1110.69 0v1.21a4.66 4.66 0 01-5.34 5z",
    fill: "#0062ff"
  }))));
}; // The types and DocGen commentary for the component props,
// in alphabetical order (for consistency).
// See https://www.npmjs.com/package/prop-types#usage.

HTTPErrorSvg404.propTypes = {
  className: string
};